export default __webpack_public_path__ + "static/media/Certificada Mental Health.be6dfe7c.jpg";